import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '@/i18n';
import { cn } from '@/lib/utils';

/** Compact EN/RW toggle (French-ready — driven by SUPPORTED_LANGUAGES). */
export function LanguageSwitch({ className }: { className?: string }) {
  const { i18n } = useTranslation();
  return (
    <div className={cn('flex items-center gap-0.5 rounded-xl border bg-card p-0.5', className)}>
      {SUPPORTED_LANGUAGES.map((lng) => (
        <button
          key={lng}
          type="button"
          aria-pressed={i18n.resolvedLanguage === lng}
          onClick={() => void i18n.changeLanguage(lng)}
          className={cn(
            'rounded-lg px-2 py-1 text-[11px] font-semibold uppercase transition-colors',
            i18n.resolvedLanguage === lng ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:text-foreground',
          )}
        >
          {lng}
        </button>
      ))}
    </div>
  );
}
